export default __webpack_public_path__ + "static/B0014-646051ce32c91039b866d3e24a6cf8ee.png";